import styled from 'styled-components'

// Panel styles
export const PanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: min(25rem, calc(100vw - 1rem));
  padding: 0 1.5rem 1.5rem;
`

export const PanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
`

export const VisibleCount = styled.span`
  color: var(--sl-fg-base, #2a2f35);
  font-size: 0.875rem;
  line-height: 1.25rem;
`

export const ResetButton = styled.button`
  border: none;
  padding: 0;
  background: none;
  color: var(--primary, #1a73e8);
  font-size: 0.875rem;
  font-weight: 600;

  &:hover {
    color: var(--sl-fg-accent-hover);
  }
`

export const PanelList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  overflow: visible;
`

// Sortable item styles
export const Item = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  min-height: 2.5rem;
  border: none;
  border-radius: 0.75rem;
  background-color: transparent;
  padding: 0.75rem 0.75rem;
  transition:
    background-color 0.2s ease,
    color 0.2s ease;

  &[data-selected='true'] {
    background-color: #edf3fb;
  }

  &:not([data-selected='true']):hover {
    background-color: #f7faff;
  }

  &:focus-within {
    outline: 2px solid var(--primary, #1a73e8);
    outline-offset: 2px;
  }
`

export const DragHandle = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  padding: 0;
  background: transparent;
  color: var(--sl-fg-base-soft);
  cursor: grab;
  border-radius: var(--sl-radius-1);
  flex-shrink: 0;

  &:active,
  &[data-dragging='true'] {
    cursor: grabbing;
  }
`

export const ItemLabel = styled.span`
  flex: 1;
  text-align: left;
  color: var(--sl-fg-base, #2a2f35);
  font-size: 0.875rem;
  line-height: 1.25rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const HiddenCheckbox = styled.input.attrs({
  type: 'checkbox'
})`
  position: absolute;
  opacity: 0;
  width: 1px;
  height: 1px;
  margin: 0;
  pointer-events: none;
`

export const ItemContent = styled.label`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex: 1;
  min-width: 0;
  margin: 0;
  cursor: pointer;

  &[data-locked='true'] {
    cursor: not-allowed;
  }
`

export const ToggleIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.25rem;
  color: var(--primary, #1a73e8);

  &[data-locked='true'] {
    color: var(--sl-fg-muted, #8e98a3);
  }
`
